import { SET_HASH } from './../const';

export default (hash) => {
    return {
      type: SET_HASH,
      hash: hash
    }
};